<template>
  <client-only>
    <div :class="prefixCls">
      <EditHeader
        v-if="model"
        ref="editHeader"
        :name="siteInfo.name"
        :model="model"
        :current-edit-site="currentEditSite"
        :device="device"
        :full-screen="fullScreen"
        :ai-panel-open="aiPanelOpen"
        :ai-panel-floating="aiPanelFloating"
        @publish="onPublish"
        @clear-select="onClearWidget"
        @back="onBack"
        @lang-change="onLangChange"
        @page-change="onPageChange"
        @device-change="deviceChange"
        @toggle-full-screen="(val) => (fullScreen = val)"
        @toggle-ai-panel="toggleAiPanel"
      />
      <div v-if="currentEditSite" class="edit-content">
        <div v-show="!fullScreen" class="z-10 edit-content__left">
          <widget-columns ref="widgetColumns" :settings="ColumnsSetting" @show-app-setting="applicationSettingClick" />
          <div class="edit-widget-global">
            <!-- 区块树 / 页面菜单区域 -->
            <div class="edit-widget-menu">
              <div v-if="SiteMenu.columnIndex === 0" class="edit-widget-wrapper">
                <widget-tree
                  v-if="currentEditSite.widgetList.length"
                  v-model="currentEditSite.widgetList"
                  :select-widget="selectWidget"
                  @item-click="onTreeItemClick"
                />
                <div class="add-block-wrapper" @click="handleShowAddBlock">
                  <div class="add-block-btn">
                    <div class="icon-box">
                      <icon-upload class="icon" />
                    </div>
                    <span class="text">添加区块</span>
                    <div class="plus-icon">+</div>
                  </div>
                </div>
              </div>
              <column-menu
                v-if="SiteMenu.columnIndex === 1"
                class="edit-widget-wrapper"
                :model="currentEditSite.loginSetting"
                @item-click="onColumnItemChange"
              />
              <column-global-menu
                v-if="SiteMenu.columnIndex === 2"
                class="edit-widget-wrapper"
                :model="getGlobalColumns"
                @item-click="onColumnItemChange"
              />
            </div>
          </div>
        </div>
        <div class="edit-content__wrapper" :class="{ 'full-screen': fullScreen, 'is-ai-wide': aiPanelOpen && !aiPanelFloating }">
          <div
            ref="editContent"
            class="edit-content__center"
            :class="[
              (!fullScreen && DeviceClassMapping[device]) || '',
              currentEditSite.globalSetting.standAloneMode && StandAloneClassName,
            ]"
            :style="{ ...currentEditSite.globalSetting.__vars }"
          >
            <div
              v-show="isShowColor(currentEditSite.globalSetting)"
              class="edit-back-ground-fixed border-none shadow-none"
              :class="!fullScreen && DeviceClassMapping[device]"
            />
            <div
              v-show="isShowBackgroundImage(currentEditSite.globalSetting)"
              class="border-none shadow-none w-full overflow-hidden edit-back-ground-fixed"
              :class="!fullScreen && DeviceClassMapping[device]"
            >
              <div class="w-full h-full" :style="computeGlobalBackgroundStyle" />
            </div>
            <div
              v-if="model"
              id="site-body"
              class="edit-content__center--wrapper"
              :style="{
                background: isShowColor(currentEditSite.globalSetting)
                  ? currentEditSite.globalSetting.backgroundColor
                  : '',
              }"
            >
              <module-navigation-widget
                :model="currentEditSite.moduleNavigationSetting"
                :site="currentEditSite"
                :device="device"
                editing
              />
              <support-setting-widget :model="currentEditSite.supportSetting" editing />
              <draggable
                v-model="currentEditSite.widgetList"
                class="edit-content__center--block"
                v-bind="draggableOptions"
                :move="checkMove"
                @change="onChange"
                @add="addMethod"
              >
                <widget-body
                  v-for="(w, index) in currentEditSite.widgetList"
                  :key="w.id + index"
                  class="widget-item"
                  :model="currentEditSite"
                  :index="index"
                  :widget="w"
                  :selected="selectWidget === w"
                  :is-default="w.getMenuInfo().isDefault"
                  :can-drag="w.getMenuInfo().draggable"
                  @add="onTreeItemClick"
                  @show-add-block="handleShowAddBlock"
                >
                  <component
                    :is="w.name.replace('Model', '')"
                    :class="w.id"
                    :model="w"
                    :site="currentEditSite"
                    :editing="true"
                    :device="device"
                    class="widget-item"
                    @click.native="clickWidgetMethod(w)"
                  >
                  </component>
                </widget-body>
              </draggable>
              <site-modals :site="currentEditSite" :device="device" :editing="true" />
            </div>
            <portal-target name="destination" />
            <portal-target name="mission-center" />
            <portal-target name="dialog-collection" />
            <portal-target name="cycle-package" />
          </div>
          <div
            v-if="$store.getters.isMobile && !fullScreen"
            class="ml-4 edit-content__mobile-handle"
            :class="DeviceClassMapping[device] || ''"
          >
            <actions-bar
              :select-widget="selectWidget"
              :widget-list="currentEditSite.widgetList"
              @up="moveSelectWidget"
              @down="moveSelectWidget"
            />
          </div>
        </div>
        <div v-show="!fullScreen" class="edit-content__right" :class="{ 'is-ai-wide': aiPanelOpen && !aiPanelFloating }">
          <edit-right
            v-if="selectWidget"
            ref="edit"
            :device="device"
            :select-widget="selectWidget"
            :site-lang-model="model"
            :current-site="currentEditSite"
            @clear-select="onClearWidget"
            @clone="addCloneWidget"
            @delete-widget="deleteWidgetMethod"
          />
          <guide-panel v-else />
        </div>
        <create-page-dialog ref="createPage" :domain="baseInfo.baseDomain" />
        <SiteAiPanel
          ref="siteAiPanel"
          :site-ai-url="siteAiUrl"
          :model="model"
          :select-widget="selectWidget"
          :site-info="siteInfo"
          :base-info="baseInfo"
          :page-list="pageList"
          :full-screen="fullScreen"
          @apply-modules="applyModules"
          @apply-config-update="applyConfigUpdate"
          @select-widget="handleAiSelectWidget"
          @open-activity="notifyParentOpenActivity"
          @open-change="aiPanelOpen = $event"
          @floating-change="aiPanelFloating = $event"
        />
      </div>
      <modules-modal ref="modulesModal" :site="currentEditSite" @add="onTreeItemClick" />
    </div>
  </client-only>
</template>

<script>
import draggable from 'vuedraggable'
import { Loading, Message } from 'element-ui'
import { cloneDeep } from 'lodash-es'
import { WidgetModelNames } from '~/enums/siteEnum'
import GuidePanel from '~/site/components/guidePanel.vue'
import SettingMenu from '~/site/components/settingMenu'
import WidgetColumns from '~/site/components/widgetColumns.vue'
import GlobalMenu from '~/site/components/globalMenu'
import EditHeader from '~/site/components/editHeader'
import WidgetBody from '~/site/components/widgetBody'
import EditRight from '~/site/components/editRight'
import iconUpload from '@/assets/svg/icon/iconUpload.svg'
import ColumnMenu from '~/site/components/columnMenu/index.vue'
import ModulesModal from '~/components/modulesModal/index.vue'
import SiteAiPanel from '~/site/components/siteAiPanel.vue'
import ColumnGlobalMenu from '~/site/components/columnMenu/global.vue'
import SiteCore, { postReady, getSiteBuilderDataByService, getIpInfo } from '~/site/core'
import langCore from '~/site/core/language'
import NodeUrl from '~/utils/url'
import { widgetComponents } from '~/site/model/components'
import { useGlobSetting } from '~/hooks/useGlobSetting'
import { disabledSortList } from '~/config/draggable.js'
import { useAssets } from '~/hooks/useAssets'
import WidgetTree from '~/site/components/widgetTree'
import { DefaultDevice, DeviceClassMapping } from '~/settings/deviceSetting'
import { checkInIframe, off, on } from '~/utils/dom'
import { StandAloneClassName } from '~/enums/DomEnum'
import SiteModals from '~/site/components/modals'
import { computeBackgroundStyle, isShowColor, isShowBackgroundImage, openIntro } from '~/site/model/helper'
import actionsBar from '~/site/components/actionsBar'
import { insertAddStep, insertSortStep, postMessage, sendMessage } from '~/utils/event'
import { PostMessageEvent } from '~/enums/postMessageEvent'
import { SiteModel } from '~/site/model'
import { SiteColumnsNameEnum, SiteEnum, ColumnsSetting } from '~/enums/siteEnum'
import CreatePageDialog from '~/site/components/editMenu/CreatePageDialog'
import { DeviceEnum, DeviceWidthEnum } from '~/enums/deviceEnum'
import deleteSvg from '~/assets/svg/icon/delete.svg'
import { tutorialKey, AI_BUILD_URL } from '~/config'
import langConfigMixins from '~/mixins/langConfigMixins'
import Bus from '~/site/model/bus'

export default {
  name: 'SiteEditPage',
  components: {
    iconUpload,
    ModulesModal,
    SiteAiPanel,
    deleteSvg,
    GuidePanel,
    ColumnGlobalMenu,
    WidgetColumns,
    actionsBar,
    CreatePageDialog,
    draggable,
    EditHeader,
    SettingMenu,
    GlobalMenu,
    WidgetBody,
    EditRight,
    SiteModals,
    ...widgetComponents,
    WidgetTree,
    ColumnMenu,
  },
  mixins: [langConfigMixins],
  async asyncData({ params, redirect, store, route, app }) {
    return await getSiteBuilderDataByService({ params, redirect, store, route, app })
  },
  data() {
    const { prefixCls } = useGlobSetting()
    return {
      StandAloneClassName,
      ColumnsSetting,
      columnIndex: 0,
      loadingService: '',
      domain: '',
      device: DefaultDevice,
      DeviceClassMapping,
      prefixCls: prefixCls + '-edit',
      prefix: prefixCls,
      model: {},
      pLang: '',
      selectWidget: null,
      web: {},
      canDragTo: false,
      saveLoading: false,
      siteBuildId: '',
      siteInfo: {},
      pageList: [],
      baseInfo: {},
      pageInfo: {},
      lang: {},
      languages: [],
      aiPanelOpen: false,
      aiPanelFloating: false,
      siteAiUrl: (() => {
        const env = process.env.RUN_ENV
        // 本地开发时指向本地 5173 服务，客户端用访问域名以支持局域网调试
        if (env === 'dev') {
          return process.client ? `http://${window.location.hostname}:5173/embed` : 'http://localhost:5173/embed'
        }
        const prefix = AI_BUILD_URL[env] || AI_BUILD_URL.release
        return `${prefix}/embed`
      })(),
      langList: [],
      notice: '',
      draggableOptions: {
        animation: 120,
        handle: '.move-btn',
      },
      computeBackgroundStyle,
      isShowColor,
      isShowBackgroundImage,
      fullScreen: false,
    }
  },
  computed: {
    SiteColumnsNameEnum() {
      return SiteColumnsNameEnum
    },
    globalSettings() {
      return this.currentEditSite.getGlobalSettings()
    },
    currentEditSite() {
      return this.model?.site || null
    },
    computeGlobalBackgroundStyle() {
      if (!this.currentEditSite) {
        return {}
      }
      const gSetting = { ...this.currentEditSite.globalSetting }
      if (this.device === DeviceEnum.MOBILE) {
        const bgImage = gSetting.backgroundImage
        Object.assign(gSetting, gSetting.mobileBackground)
        if (!gSetting.backgroundImage) {
          gSetting.backgroundImage = bgImage
        }
      }
      return computeBackgroundStyle(gSetting)
    },
    getGlobalColumns() {
      const currentEditSite = this.currentEditSite
      return [
        {
          title: '页面',
          children: [
            currentEditSite.globalSetting,
            currentEditSite.seoSetting,
            currentEditSite.moduleNavigationSetting,
          ],
        },
        {
          title: '全站',
          children: [
            currentEditSite.langSetting,
            // currentEditSite.pwaSetting,
            currentEditSite.noticeSetting,
            currentEditSite.__assetsSetting,
            currentEditSite.missionCenterSetting,
            // currentEditSite.moduleNavigationSetting,
            currentEditSite.supportSetting,
          ],
        },
      ]
    },
    siteAiOrigin() {
      try {
        return new URL(this.siteAiUrl).origin
      } catch (e) {
        return ''
      }
    },
    isAiWide() {
      return this.aiPanelOpen && !this.aiPanelFloating
    },
  },
  watch: {
    'currentEditSite.globalSetting.standAloneMode'(newVal) {
      this.$store.commit('site/SET_IS_STAND_ALONE_MODE', newVal)
    },
    isAiWide() {
      // AI 面板切换展示会改变画布宽度，若头部模块为固定模式需动态重新初始化其固定宽度
      setTimeout(() => {
        this.setDefaultDeviceWidth()
        Bus.$emit('aiPanelToggle')
      }, 300)
    },
  },
  errorCaptured(err, vm, info) {
    // 兜底捕获子组件渲染/watcher 错误，避免冒泡到 Nuxt 错误页导致整页崩溃
    console.error('[Editor] 渲染错误:', {
      component: vm?.$options?.name || vm?.$options?.__file || 'unknown',
      info,
      error: err,
      stack: err?.stack,
    })
    Message.error(`渲染出错：${err?.message || err}，详见控制台`)
    return false
  },
  beforeDestroy() {
    off(document.body, 'click', this.bindTextEditorEvent)
    off(window, 'message', this.receiveMessage)
  },
  mounted() {
    on(window, 'message', this.receiveMessage)
    const { mid, pid, domain } = this
    // 初始化信息 获取资源和应用支持的语言列表
    const { getAssets, setSiteLangList, setProjectLangList } = useAssets(this)
    setProjectLangList(this.siteInfo?.project?.languages)
    setSiteLangList(this.langList)
    getAssets(domain, mid, pid)
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.init()
    }
  },
  methods: {
    async init() {
      // 挂载国际化等基础配置
      this.$store.commit('editor/SET_EDIT_MODE', true)
      await this.initSitePage()
      await this.getMerchantInfo()
      this.$nextTick(() => {
        if (!(this.web && Object.keys(this.web).length)) {
          // 没有提交过,手动提交一次
          const headerRef = this.$refs.editHeader
          headerRef && headerRef.submit()
        }
        this.setDefaultDeviceWidth()
        this.bindTextEditorEvent()
        this.addChangePageListener()
        window.__site_builder_edit_init = true
        postReady()
        // this.applyModules()
      })
    },
    setDefaultDeviceWidth() {
      this.$nextTick(() => {
        const width = document.getElementById('site-body')?.clientWidth
        this.$store.commit('editor/SET_PC_DEVICE_WIDTH', width)
        this.$store.commit('editor/SET_DEVICE_WIDTH', width)
      })
    },
    async getMerchantInfo() {
      const [merchantInfoErr, merchantInfo] = await this.$utils.to(
        this.$api.merchant.info({ merchant_id: this.siteInfo.merchant_id })
      )
      if (merchantInfo && !merchantInfoErr) this.$store.commit('project/SET_MERCHANTINFO', merchantInfo)
    },
    addChangePageListener() {
      this.SitePage.$bus.$on('change-page', (value) => {
        this.selectWidget = null
        this.SiteMenu.close()
        this.currentEditSite.toggleSitePage(value)
      })
    },
    handleShowAddBlock(index) {
      this.$refs?.modulesModal?.init(index)
    },
    async getOriginUrl() {
      let result = ''
      const inIframe = checkInIframe()
      if (inIframe) {
        const detail = await sendMessage({ type: PostMessageEvent.GET_ORIGIN_URL })
        result = decodeURI(detail.data)
      } else {
        result = decodeURI(location.href)
      }
      return result
    },
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      const map = {}
      res.data.forEach((c) => {
        map[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: res.data,
        currencieMap: map,
      })
    },
    async initSitePage() {
      const { web, pageList } = this
      await this.getCurrencies()
      await getIpInfo(this)
      const url = new NodeUrl(await this.getOriginUrl())
      const page = url.get('page')
      const pageConfig = pageList.find((item) => item.link === page)
      const isHome = !pageConfig || pageConfig?.id === SiteEnum.BASE_PAGE
      const siteInfo = isHome ? { web } : pageConfig.conf
      const pageId = isHome ? SiteEnum.BASE_PAGE : pageConfig.id.toString()
      this.baseInfo.pageId = pageId
      this.SitePage.setInfo(cloneDeep(this.siteInfo))
      this.SitePage.setCurrent(pageId)
      if (!isHome && siteInfo?.web?.site?.pageInfo?.id) {
        siteInfo.web.site.pageInfo.id = pageId
      }
      this.model = new SiteCore({
        siteInfo,
        languages: this.languages,
        langList: this.langList,
        baseInfo: this.baseInfo,
        pageList: this.pageList,
        homeInfo: this.web,
      })
    },
    bindTextEditorEvent() {
      on(document, 'click', this.clearCurrentRichTextId)
    },
    moveSelectWidget(oldIndex, newIndex) {
      this.currentEditSite.moveSelectWidget(this.selectWidget, oldIndex, newIndex)
    },
    clearCurrentRichTextId() {
      this.$store.commit('editor/SET_CURRENT_RICH_TEXT_ID', null)
    },
    deviceChange(value) {
      this.device = value
      this.$store.commit('editor/SET_DEVICE', value)
      this.setDeviceWidth()
    },
    resetToDefault() {
      this.SiteMenu.close()
      this.selectWidget = null
      this.model = null
    },
    async onPageChange(value) {
      const isAdd = value === 'append'
      if (isAdd) {
        this.$refs.createPage && this.$refs.createPage.init()
        return
      }
      const current = this.SitePage.list.find((item) => item.id.toString() === value)
      this.closeMenus()
      this.$refs?.widgetColumns?.setCurrent(0)
      this.SiteMenu.setColumnIndex(0)
      this.SiteMenu.setColumnChildIndex(null)
      await this.$nextTick()
      await this.SitePage.to(current.name)
    },
    onPublish() {
      this.loadingService = Loading.service({ text: '正在发布...' })
      postMessage({ type: PostMessageEvent.PUBLISH })
    },
    onBack() {
      postMessage({ type: PostMessageEvent.BACK })
    },
    async onLangChange(value) {
      this.siteInfo.conf.web = this.model.getConfig()
      this.resetToDefault()
      await this.$nextTick()
      this.model = new SiteCore({
        siteInfo: this.siteInfo,
        langList: this.langList,
        languages: langCore.cache,
        lang: value,
      })
    },
    deleteWidgetMethod() {
      const currentIndex = this.currentEditSite.widgetList.findIndex((item) => item.id === this.selectWidget.id)
      insertAddStep(this, { element: cloneDeep(this.selectWidget), index: currentIndex })
      this.$store.commit('editor/CLEAR_STORAGE_STEP')
      const index = this.currentEditSite.deleteWidget(this.selectWidget)
      this.selectWidget = this.currentEditSite.widgetList[index]
    },
    addCloneWidget(model) {
      const index = this.currentEditSite.widgetList.findIndex((item) => item.id === this.selectWidget.id)
      this.currentEditSite.addCloneWidgetByIndex(index, model)
    },
    addMethod(event) {
      const oldIndex = event.oldIndex
      const newIndex = event.newIndex
      const widgetList = this.currentEditSite.widgetList
      const widget = widgetList[oldIndex]
      const menuInfo = widget && widget.getMenuInfo
      if (menuInfo && typeof menuInfo === 'function') {
        const Model = menuInfo().model
        this.currentEditSite.replaceWidgetByIndex(Model, newIndex)
      }
    },
    receiveMessage(event) {
      const origin = event.origin || event.originalEvent.origin
      if (!origin) return

      console.log('[SiteBuilder] 收到 postMessage:', { origin, data: event.data })

      // AI iframe 子窗口的消息由 SiteAiPanel 组件自行处理，这里只处理父窗口消息
      if (origin === this.siteAiOrigin) return

      this.dealMessageData(event.data)
    },
    // SiteAiPanel 组件的 AI_SELECT_WIDGET：选中指定 widget 并同步右侧面板
    handleAiSelectWidget(widgetId) {
      if (!widgetId || !this.currentEditSite) return
      const widget = this.currentEditSite.widgetList.find((w) => w.id === widgetId)
      if (widget) {
        this.selectWidget = widget
        this.closeMenus()
        this.setCurrentWidgetId()
      }
    },
    toggleAiPanel() {
      this.$refs.siteAiPanel?.togglePanel()
    },
    dealMessageData(data) {
      switch (data.type) {
        case PostMessageEvent.RELEASE_SUCCESS:
          Message.success('发布成功')
          this.loadingService.close()
          break
        case PostMessageEvent.RELEASE_ERROR:
          Message.error(data?.detail || '发布失败')
          this.loadingService.close()
          break
        case PostMessageEvent.SHOW_TUTORIAL:
          this.startTutorial()
          break
        case PostMessageEvent.HIDE_LOADING:
          this.loadingService.close()
          break
        case PostMessageEvent.MODULE_APPLY:
          this.applyModules(data)
          break
        case PostMessageEvent.AI_ACTIVITY_MODULE_APPLY:
          this.insertActivityModule(data)
          break
      }
    },
    applyModules(data) {
      const { payload } = data
      if (!payload || !Array.isArray(payload.modules)) {
        console.warn('MODULE_APPLY 数据格式错误:', data)
        return
      }

      const site = this.currentEditSite
      if (!site) return

      // 清空所有模块
      site.widgetList.splice(0, site.widgetList.length)

      for (const module of payload.modules) {
        const { config } = module
        // 兼容新旧数据格式：旧格式 name 在 config.name，新格式在 module.name
        const modelName = module.name || (config && config.name)
        if (!config || !modelName) continue

        try {
          // 全局样式 — 更新现有实例
          if (modelName === 'GlobalSettingModel') {
            Object.assign(site.globalSetting, config)
            site.globalSetting.__vars = site.globalSetting.generateVars()
          } else if (modelName === 'LoginSettingModel') {
            // 登录设置 — 更新现有实例
            Object.assign(site.loginSetting, config)
          } else {
            // 常规模块 — 通过 registerModel 创建实例并添加到 widgetList
            const Model = SiteModel.registerModel[modelName]
            if (Model) {
              site.widgetList.push(new Model(config))
              console.log(`[MODULE_APPLY] 正在添加模块: ${modelName}`, module.title || '')
            } else {
              console.warn(`模型未注册: ${modelName}`)
            }
          }
        } catch (e) {
          console.error(`[MODULE_APPLY] 模块应用失败: ${modelName}`, e, module)
          Message.error(`模块「${modelName}」应用失败，详见控制台`)
        }
      }
      console.log('MODULE_APPLY 应用完成:', payload)
    },
    applyConfigUpdate(data) {
      const { siteConfig } = data.payload || {}
      if (!siteConfig?.site) {
        console.warn('AI_CONFIG_UPDATE 数据格式错误:', data)
        return
      }

      const site = this.currentEditSite
      if (!site) return

      const { widgetList, globalSetting, loginSetting, seoSetting, langSetting, pwaSetting, noticeSetting, moduleNavigationSetting, supportSetting, missionCenterSetting } = siteConfig.site

      // 替换 widgetList：用完整配置重建模型实例（同步重建，单个模块失败跳过不影响其余）
      if (Array.isArray(widgetList)) {
        const newModels = []
        const failedWidgets = []
        for (const widgetConfig of widgetList) {
          const name = widgetConfig?.name
          const Model = name && SiteModel.registerModel[name]
          if (!Model) {
            console.warn(`模型未注册: ${name}`)
            continue
          }
          try {
            // 移除运行时字段（data/options），避免 mergeToObject 递归时遇到 undefined 报错
            const { data, options, ...cleanConfig } = widgetConfig
            newModels.push(new Model(cleanConfig))
            console.log(`[AI_CONFIG_UPDATE] 正在添加模块: ${name}`, widgetConfig.title || '')
          } catch (e) {
            failedWidgets.push(name)
            console.error(`[AI_CONFIG_UPDATE] 模块构造失败: ${name}`, e, widgetConfig)
          }
        }
        site.widgetList.splice(0, site.widgetList.length)
        this.$nextTick(() => {
          newModels.forEach((m) => site.widgetList.push(m))
        })
        if (failedWidgets.length) {
          Message.error(`以下模块应用失败：${failedWidgets.join('、')}，详见控制台`)
        }
      }

      // 更新全局设置模块（整体替换属性，保持实例引用）
      if (globalSetting) {
        try {
          Object.assign(site.globalSetting, globalSetting)
          site.globalSetting.__vars = site.globalSetting.generateVars()
        } catch (e) {
          console.error('[AI_CONFIG_UPDATE] 更新全局样式失败:', e, globalSetting)
          Message.error('全局样式配置应用失败，详见控制台')
        }
      }
      const settingList = [
        ['loginSetting', loginSetting],
        ['seoSetting', seoSetting],
        ['langSetting', langSetting],
        ['pwaSetting', pwaSetting],
        ['noticeSetting', noticeSetting],
        ['moduleNavigationSetting', moduleNavigationSetting],
        ['supportSetting', supportSetting],
        ['missionCenterSetting', missionCenterSetting],
      ]
      for (const [key, settingConfig] of settingList) {
        if (!settingConfig) continue
        try {
          Object.assign(site[key], settingConfig)
        } catch (e) {
          console.error(`[AI_CONFIG_UPDATE] 更新 ${key} 失败:`, e, settingConfig)
        }
      }

      // 清除当前选中，强制视图刷新
      this.selectWidget = null
      this.setCurrentWidgetId()
      console.log('AI_CONFIG_UPDATE 应用完成:', siteConfig)
    },
    // 活动链路：AI 面板识别到「创建活动」意图后发来 AI_OPEN_ACTIVITY，
    // sitebuilder 自身不具备打开活动配置页面的能力，仅透传给商城父页(kop-shop)由其打开
    notifyParentOpenActivity(data) {
      const payload = data?.payload
      // 兼容后端 snake_case 的 activity_type 与契约的 activityType，归一化为 activityType
      const activityType = payload?.activityType ?? payload?.activity_type
      if (!activityType) {
        console.warn('[SiteBuilder] AI_OPEN_ACTIVITY 数据格式错误:', data)
        return
      }
      const normalized = { ...payload, activityType }
      console.log('[SiteBuilder] 转发 AI_OPEN_ACTIVITY 到父页:', normalized)
      postMessage({ type: PostMessageEvent.AI_OPEN_ACTIVITY, payload: normalized })
    },
    // AI 链路：商城父页(kop-shop)创建活动成功后发来 AI_ACTIVITY_MODULE_APPLY，
    // 往 widgetList 追加对应活动模块（带 bizId/activityType 关联到活动）
    insertActivityModule(data) {
      const { modelClass, config } = data?.payload || {}
      const Model = modelClass && SiteModel.registerModel[modelClass]
      if (!Model) {
        console.warn(`活动模块未注册: ${modelClass}`)
        return
      }
      try {
        const widget = new Model({ name: modelClass, ...config })
        const list = this.currentEditSite.widgetList
        // 页脚(FooterWidgetModel)永远是最后一个模块，活动模块插入到它之前
        const footerIdx = list.findIndex((w) => w.name === WidgetModelNames.FooterWidgetModel)
        list.splice(footerIdx >= 0 ? footerIdx : list.length, 0, widget)
        this.selectWidget = widget
        this.closeMenus()
        this.setCurrentWidgetId()
        // 等 vuedraggable 渲染 + 活动数据加载完成后，滚动到新模块
        this.$nextTick(() => {
          const el = document.getElementById(widget.id)
          if (el) this.scrollToActivityWidget(el)
        })
      } catch (e) {
        console.error(`活动模块应用失败: ${modelClass}`, e)
        Message.error(`活动模块「${modelClass}」应用失败，详见控制台`)
      }
    },
    // 活动模块数据是异步加载的（累充/签到/抽奖等先 v-show 隐藏、加载完再显示），
    // 若在加载前滚动，模块高度只剩边框，定位会偏。这里等高度稳定（数据加载完成）后再滚。
    scrollToActivityWidget(el) {
      let done = false
      let scrollTimer = null
      const doScroll = () => {
        if (done) return
        done = true
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      // ResizeObserver 监听高度：数据加载完成 → 高度从「仅边框」跳到实际高度 → 防抖后滚动
      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => {
          clearTimeout(scrollTimer)
          if (el.offsetHeight < 60) return // 数据未加载完，高度只剩边框，继续等
          scrollTimer = setTimeout(doScroll, 200) // 高度稳定 200ms 后滚
        })
        ro.observe(el)
      }
      setTimeout(doScroll, 3000) // 兜底：3 秒后无论是否加载完都滚一次
    },
    startTutorial() {
      const isTutorialPass = sessionStorage.getItem(tutorialKey)
      if (isTutorialPass) return
      this.selectWidget = this.currentEditSite.widgetList[1]
      this.closeMenus()
      this.$refs.widgetColumns.handleItemClick({}, 0)
      this.setCurrentWidgetId()
      this.$store.commit('site/SET_TUTORIAL_ENABLE', true)
      this.$nextTick(() => {
        openIntro(this)
      })
    },
    onChange(data) {
      const { moved } = data
      if (moved) {
        insertSortStep(this, [moved.element.id, moved.newIndex, moved.oldIndex])
      }
    },
    checkMove(evt) {
      // 用固定的模块标识 getMenuInfo().title 判断，而不是用户可编辑的 .title
      const title = evt.relatedContext.element?.getMenuInfo?.().title || null
      this.canDragTo = !disabledSortList.includes(title)
      return this.canDragTo
    },
    changeWidgetByIndex(i) {
      this.selectWidget = this.currentEditSite.widgetList[i]
      this.closeMenus()
      this.setCurrentWidgetId()
      this.checkMenuSelected()
    },
    checkMenuSelected() {
      if ([WidgetModelNames.CyclePackageWidgetModel].includes(this.selectWidget?.name)) {
        this.selectWidget.__onMenuSelected(this.selectWidget, this)
      }
    },
    onTreeItemClick(model, index) {
      this.changeWidgetByIndex(index)
    },
    onClearWidget() {
      this.selectWidget = null
      this.setCurrentWidgetId()
    },
    clickWidgetMethod(w) {
      this.selectWidget = w
      this.closeMenus()
      this.$refs.widgetColumns.handleItemClick({}, 0)
      this.setCurrentWidgetId()
    },
    setCurrentWidgetId() {
      this.$store.commit('editor/SET_SELECT_WIDGET_ID', this.selectWidget?.id)
    },
    closeMenus() {
      this.SiteMenu.close()
      this.$store.commit('user/CLEAR_SITE_LOGIN_USER_MODAL')
      this.$store.commit('editor/SET_SUB_ID', null)
      this.$store.commit('user/SET_SITE_LOGIN_USER', null)
      this.$store.commit('menu/REMOVE_MENU_KEY')
      this.$store.commit('site/SET_MISSION_CENTER_VISIBLE', false)
      this.$store.commit('site/SET_CURRENT_VISIBLE_DIALOG_ID', null)
      this.$store.commit('site/SET_CYCLE_PACKAGE_VISIBLE', false)
    },
    onColumnItemChange(model, index) {
      this.selectWidget = model
      this.closeMenus()
      this.selectWidget && this.selectWidget.__onMenuSelected && this.selectWidget.__onMenuSelected(model, this)
      this.$nextTick(() => {
        if (this.selectWidget.__children) {
          this.selectWidget.__children[index].__onMenuSelected(model, this)
        }
      })
    },
    applicationSettingClick() {
      postMessage({
        type: PostMessageEvent.APPLICATION_SETTING,
        id: this.siteInfo.id,
        project_id: this.siteInfo.project_id,
      })
    },
    setDeviceWidth() {
      this.$store.commit(
        'editor/SET_DEVICE_WIDTH',
        this.device === DeviceEnum.MOBILE ? DeviceWidthEnum.MOBILE : this.$store.state.editor.pcDeviceWidth
      )
    },
  },
}
</script>

<style lang="less">
@prefix-cls: ~'@{namespace}-edit';
@delete-block-height: 48px;
@min-width: 754px; // @edit-left-w(240) + @edit-right-w(350) + @edit-mobile-w(154) + 10px;

.@{prefix-cls} {
  min-height: 100%;
  width: 100%;
  min-width: @min-width;
  overflow: auto;
  background-color: #18181b; // 更深邃的背景

  .edit-content {
    overflow: auto;
    position: relative;
    background: #0f0f11; // 画布背景改为深色，突出内容
    width: 100vw;
    display: flex;

    &__wrapper {
      width: calc(100% - 310px - 240px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: radial-gradient(#333 1px, transparent 1px); // 添加点阵背景
      background-size: 20px 20px;
      transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);

      &.is-ai-wide {
        width: calc(100% - 310px - 380px);
      }

      &.full-screen {
        width: 100%;
      }
    }

    .edit-back-ground-fixed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: none;

      &.@{mobile-cls} {
        top: 0;
      }
    }

    &__left {
      height: 100%;
      display: flex;
      overflow: auto;
      color: var(--text-light-color);
      border-right: 1px solid rgba(255, 255, 255, 0.06); // 更柔和的边框
      z-index: 31;
      flex-shrink: 0;
      background: var(--widget-menu-bg);
      backdrop-filter: blur(10px); // 玻璃拟态

      .edit-widget-global {
        width: 240px;
        height: calc(100vh - 56px);
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 8px;
        box-sizing: border-box;
        overflow: hidden;
        background-color: transparent; // 透明以透出背景

        // 菜单区域的外边框美化：圆角卡片 + 顶部内高光 + 底部投影
        .edit-widget-menu {
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.045) 0%, rgba(255, 255, 255, 0.02) 100%);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 6px 18px rgba(0, 0, 0, 0.28);
          flex: 1;
          min-height: 0;
          overflow: auto;
          // 去掉滚动条宽度占位（隐藏滚动条，保留滚动）
          scrollbar-width: none; // Firefox
          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }
        }
      }

      .edit-widget-wrapper {
        padding: 8px;
        background-color: transparent;

        .add-block-wrapper {
          margin-top: 8px;
          padding: 0 4px;
        }

        .add-block-btn {
          height: 40px;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px dashed rgba(255, 255, 255, 0.1);
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 0 16px;
          transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
          position: relative;
          overflow: hidden;

          .icon-box {
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 0.05);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            transition: all 0.3s ease;

            .icon {
              font-size: 14px;
              opacity: 0.6;
              transition: all 0.3s ease;
              fill: rgba(255, 255, 255, 0.8);
            }
          }

          .text {
            color: rgba(255, 255, 255, 0.6);
            font-size: 13px;
            font-weight: 500;
            transition: all 0.3s ease;
            flex: 1;
          }

          .plus-icon {
            color: rgba(255, 255, 255, 0.2);
            font-size: 16px;
            transition: all 0.3s ease;
            transform: translateX(10px);
            opacity: 0;
          }

          &:hover {
            background: rgba(var(--primary-color-rgb), 0.05);
            border-color: rgba(var(--primary-color-rgb), 0.3);
            border-style: solid;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            transform: translateY(-1px);

            .icon-box {
              background: var(--primary-color);

              .icon {
                opacity: 1;
                fill: #fff;
              }
            }

            .text {
              color: #fff;
              transform: translateX(2px);
            }

            .plus-icon {
              transform: translateX(0);
              opacity: 1;
              color: var(--primary-color);
            }
          }

          &:active {
            transform: translateY(0);
            background: rgba(var(--primary-color-rgb), 0.1);
          }
        }
      }
      .global-component {
        background-color: transparent;
        margin-top: 2px;
        padding: 12px;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(255, 255, 255, 0.03);
        }

        .active {
          background: var(--primary-color-alpha-1);
          color: var(--primary-color);
          border-radius: 6px; // 圆角

          svg {
            fill: var(--primary-color);
          }
        }

        svg {
          fill: var(--text-light-color);
          transition: fill 0.3s ease;
        }
      }
    }

    &__center {
      width: 100%;
      overflow: hidden;
      transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.5); // 强烈的阴影增加层次感

      &--wrapper {
        width: 100%;
        height: calc(100vh - 56px);
        overflow: auto;
        position: relative;
        z-index: 31;
        scrollbar-gutter: stable; // 防止滚动条出现时内容抖动

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar {
          height: 6px;
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background-color: rgba(0, 0, 0, 0.3); // 改为深色，防止在白色背景下不可见
          border: 1px solid transparent;
          background-clip: content-box;
          transition: background-color 0.3s;

          &:hover {
            background-color: rgba(0, 0, 0, 0.5);
          }

          &:active {
            background-color: rgba(0, 0, 0, 0.7);
          }
        }

        // 隐藏横向滚动条
        &::-webkit-scrollbar-corner {
          background: transparent;
        }
      }

      .widget-item {
        box-sizing: border-box;
        background-position: 50%;
        background-size: cover;
        background-repeat: no-repeat;
      }

      .edit-back-ground-image {
        background-image: var(--background-image);
        background-repeat: no-repeat;
        background-size: var(--background-image-size);
        background-position: 50%;
        opacity: var(--background--opatity);
        filter: blur(var(--background-blur));
      }

      .edit-back-ground-color {
        background: var(--global-background-gradient);
        background-color: var(--background-color);
      }

      &--block {
        position: relative;
        overflow: hidden auto;
      }
    }

    .@{mobile-cls} {
      width: 430px; // @edit-mobile-w
      height: calc(100vh - 56px - 40px); // 减去header高度和上下边距
      max-height: 844px; // 限制最大高度，模拟真实手机比例 (iPhone 12/13/14 Pro)
      overflow: auto;
      border-radius: 12px; // 减小圆角，更加现代简洁
      border: 1px solid rgba(255, 255, 255, 0.05); // 极细的边框
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); // 更加柔和的投影
      background-color: #fff; // 确保手机内部背景为白色（除非被页面背景覆盖）
      // 隐藏滚动条，模拟手机原生体验
      &::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }
    }

    &__mobile-handle.@{mobile-cls} {
      width: auto;
      left: calc(50% + 215px + 20px); // 调整handle位置
      max-height: 200px;
      background-color: transparent;
      border: none;
      box-shadow: none;
    }

    &__right {
      overflow: auto;
      width: 240px; // @edit-right-w（右侧配置面板宽度）
      background-color: var(--widget-menu-bg);
      transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);

      &.is-ai-wide {
        width: 380px;
      }
      box-sizing: border-box;
      border-left: 1px solid rgba(255, 255, 255, 0.06);
      z-index: 31;
      flex-shrink: 0;
      height: calc(100vh - var(--header-height));
      position: relative;

      .bottom-handle {
        position: absolute;
        z-index: 31;
        width: 100%;
        left: 0;
        bottom: 0;
        height: @delete-block-height;
        border-top: 1px solid rgba(255, 255, 255, 0.06);
        padding: 0 24px;
        background-color: transparent;

        .delete-svg {
          fill: var(--text-color-secondary);
          margin-right: 10px;
          transition: fill 0.3s;

          &:hover {
            fill: var(--error-color);
          }
        }
      }
    }
  }
}

.placeholder-style {
  display: block !important;
  color: transparent;
  border-style: dashed !important;
}

.application-setting {
  width: 219px;
  height: 52px;
  line-height: 52px;
  padding-left: 22px;
  transition: color linear 0.36s;
  background: var(--dark-bg);
  color: var(--text-light-color);
  @apply absolute left-0 bottom-0 flex items-center z-10 cursor-pointer;

  .icon {
    font-size: 18px;
    margin-right: 10px;
  }
}
</style>
